import { Component } from '@angular/core';
import { ContentService } from '@common/services/content.service';

@Component({
  selector: 'app-socialnetwork-icons',
  templateUrl: './socialnetwork-icons.component.html',
  styleUrls: ['./socialnetwork-icons.component.scss'],
    standalone: false
})
export class SocialnetworkIconsComponent {

  constructor(public content: ContentService) { }

}
